import PaymentProviders from "./PaymentProviders";

export default PaymentProviders;
